import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
//#region src/utils/classNames.ts
const twMerge = extendTailwindMerge({
	prefix: "tw",
	extend: {
		theme: { radius: [
			"card",
			"popover",
			"modal",
			"sheet",
			"toast"
		] },
		classGroups: { opacity: [{ opacity: ["disabled"] }] }
	}
});
const cn = (...classes) => twMerge(clsx(...classes));
//#endregion
export { cn };

//# sourceMappingURL=classNames-DcGnTh2N.js.map